import { Request } from 'api';
import { AxiosResponse } from 'axios';
import type { Calendar } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Calendar>>>;

const getIndividualCalendars = (individualId: string): ReturnType => {
    return Request.get(`/individuals/${individualId}/calendars`);
};

export default getIndividualCalendars;
